import { versusCompetitorHero } from '../../utils/images';

export default function VsCompetitorHeading({ header, descriptions }) {
	if (!header || header.length === 0) {
		header = "See why <span style={{ color: 'var(--primary' }}>facility</span>bot is the industry's leading CMMS";
	}
	if (!descriptions || descriptions.length === 0) {
		descriptions = [
			"With FacilityBot's Smart Facilities Management platform, building owners and managers have everything they need to manage and automate their operations at their fingertips.",
			"To help you compare FacilityBot's features against other CMMS systems, we have summarized some key differences below.",
		];
	}

	return (
		<section className="container versus-competitor-heading">
			<div className="versus-competitor-heading__content">
				<h1 className="versus-competitor-heading__title" dangerouslySetInnerHTML={{ __html: header }} />

				<div className="versus-competitor-heading__desc">
					{descriptions.map((description, index) => (
						<p key={index}>{description}</p>
					))}
				</div>
			</div>

			<img className="versus-competitor-heading__hero" src={versusCompetitorHero} alt="" />
		</section>
	);
}
